import React from 'react';
import JsonView from '@uiw/react-json-view';
import { darkTheme } from '@uiw/react-json-view/dark';
import { useColorMode } from '../../components/providers/ColorModeProvider';

// JsonView that follows the dashboard's light / dark mode, on a transparent background
const ThemedJsonView = ({ style = {}, ...props }) => {
  const { mode } = useColorMode();
  return (
    <JsonView
      {...props}
      style={{
        ...(mode === "dark" ? darkTheme : {}),
        "--w-rjv-background-color": "transparent",
        ...style,
      }}
    />
  );
};

export default ThemedJsonView;
